import { customerTypesSlice } from "./customerTypesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = customerTypesSlice;
const moduleUrl = '/api/appmasterdata/customer/types'

export const QPARAMS_CHANGED = "customerTypes/QParamsChanged";
export const setValidationErrors = actions.setValidationErrors;

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);